import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../header/Header';
import PageContext from '../ui/PageContext';
import Footer from '../footer/Footer';
import PersonaFloatingBadge from '../components/PersonaFloatingBadge/PersonaFloatingBadge';

export default function AppLayout() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  return (
    <div className={`admin-shell flex flex-col min-h-screen min-w-0 bg-dark-bg ${sidebarVisible ? 'has-sidebar' : ''}`}>
      <Header sidebarVisible={sidebarVisible} onToggleSidebar={() => setSidebarVisible((value) => !value)} />
      <main id="admin-main" tabIndex={-1} className="flex-grow min-w-0 bg-dark-bg">
        <PageContext />
        <div className="admin-content"><Outlet /></div>
      </main>
      <Footer />
      <PersonaFloatingBadge />
    </div>
  );
}
